import { render, staticRenderFns } from "./memberModal.vue?vue&type=template&id=0389c2c9&scoped=true"
import script from "./memberModal.vue?vue&type=script&lang=js"
export * from "./memberModal.vue?vue&type=script&lang=js"
import style0 from "./memberModal.vue?vue&type=style&index=0&id=0389c2c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389c2c9",
  null
  
)

export default component.exports